import { render } from "./AdminIndex.vue?vue&type=template&id=f6695e0e&ts=true"
import script from "./AdminIndex.vue?vue&type=script&lang=ts"
export * from "./AdminIndex.vue?vue&type=script&lang=ts"

import "./AdminIndex.vue?vue&type=style&index=0&id=f6695e0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__